export function getUserAgent() {
  return window?.navigator?.userAgent
}
